const storeList = [];

function findIndexById(id) {
    for (let i = 0, lng = storeList.length; i < lng; i++) {
        if (storeList[i].id === id) {
            return i;
        }
    }

    return -1;
}

export const store = {
    store(obj) {
        storeList.push(obj);
    },

    contains(id) {
        return findIndexById(id) >= 0;
    },

    get(id) {
        const idx = findIndexById(id);
        if (idx >= 0) {
            return storeList[idx];
        }
    },

    remove(id) {
        const idx = findIndexById(id);
        if (idx >= 0) {
            const obj = storeList[idx];
            storeList.splice(idx, 1);
            return obj;
        }
    },
};
